import React from 'react';
import Link from 'next/link';

const Author = ({metadata}) => {
    const { author } = metadata
    const names = author.split(' ')
    return (
        <div className="mb-3 flex flex-wrap items-center space-x-1 text-xs">
<Link href="/" className="dark:text-jacarta-200 text-jacarta-700 font-display hover:text-accent">
    {names[0] + " "}
    <span className="text-accent inline-flex flex-wrap items-center space-x-1">{names[1]}</span>
</Link>

        </div>
    )
}

export default Author;